import { createActorContext } from "@xstate/react";
import type { AnyStateMachine } from "xstate";

/**
 * Creates a tournament actor context for a given XState machine.
 * In production, no inspector is attached.
 * Replaces the repetitive KnockoutProvider/RoundRobinProvider/SwissProvider boilerplate.
 */
export const createTournamentContext = <TMachine extends AnyStateMachine>(machine: TMachine) =>
  createActorContext(machine);
